import styled from 'styled-components';

export const TableInner = styled.div<{ $empty?: boolean }>`
  width: ${({ $empty }) => ($empty ? '100%' : 'auto')};
  overflow: auto;
  &:last-child {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

export const EmptyContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
`;

export const MasterTilesWrapper = styled.div`
  display: flex;
  width: fit-content;
  height: 64px;
  padding: 4px 0;
  background-color: ${({ theme }) => theme.black.a0};
`;
